import { combineReducers } from 'redux';

import payroll from './payroll';
import setting from './setting';

export default combineReducers({
  payroll,
  setting,
});
